import { useMutation, useQueryClient } from '@tanstack/react-query';

import { syncDocuments } from '../services/api/documents';

export const useDocumentSync = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => syncDocuments(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};
